import { useState } from "react";
import { observer } from "mobx-react";
import { Edit2, CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, TextField, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '../../icons/save-icon.png';

const RenameSectionTitleModal = observer(({ uiStore, section, updateData, category, handleCloseBtn, index}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(section.name === section.title ? section?.title + ' ' + (index + 1) : section.title);


    const save = async () => {
        setLoading(true);
        const data = await uiStore.renameSectionTitle(section, category, value);
        updateData(data);
        setLoading(false);
        setShow(false);
        handleCloseBtn(false);
    }

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    return (
        <Box>

            <MenuItem onClick={() => setShow(true)}>
                <ListItemIcon>
                    <Edit2
                        size="24"
                        variant="Bulk"
                    />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '14px' }}>Rename Title</ListItemText>
            </MenuItem>


            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px', width: '370px' }, variant: 'round' }}
            >

                <DialogTitle>
                    Rename {section.name === section.title ? section?.title + ' ' + (index + 1) : section.title} Section Title
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        sx={{ margin: '20px 0' }}
                        value={value}
                        disabled={loading}
                        onChange={handleChange}
                        label={'New Section Title'}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary"
                        endIcon={
                            <img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />
                        }
                    >
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box >
    );
});

export default RenameSectionTitleModal;
